
export enum LinkType {
	Definition = 'D',
	Abbreviation = 'A'
}
